import HyperDX from '@hyperdx/browser';
import { useCallback, useContext } from 'react';
import { AnalyticsContext, reportAction } from 'shared';
// Keyed by id, so repeat consumers of one cached OTA token lookup collapse to a
// single event while a second Prove run or application still reports.
const reportedIds = new Set();
/**
 * Tracks the Prove session id and credit application uuid in Google Analytics
 * and HyperDX. A browser session can produce several of each, so every distinct
 * id is emitted as its own event rather than only stamped on the session.
 */
const useIdentifierTracking = () => {
    const { analytics } = useContext(AnalyticsContext);
    const trackProveSessionId = useCallback((proveSessionId, { componentName, flow }) => {
        if (!proveSessionId || reportedIds.has(`prove:${proveSessionId}`))
            return;
        reportedIds.add(`prove:${proveSessionId}`);
        analytics?.track('ProveSessionCreated', {
            prove_session_id: proveSessionId,
            prove_flow: flow,
            page: window.location.pathname,
        });
        HyperDX.setGlobalAttributes({ proveSessionId });
        reportAction('ProveSessionCreated', {
            componentName,
            actionType: 'ProveSessionCreated',
            actionURL: window.location.pathname,
            actionData: { proveFlow: flow, proveSessionId },
        });
    }, [analytics]);
    const trackCreditApplicationId = useCallback((creditApplicationId, { componentName, source, }) => {
        if (!creditApplicationId ||
            reportedIds.has(`application:${creditApplicationId}`))
            return;
        reportedIds.add(`application:${creditApplicationId}`);
        analytics?.track('CreditApplicationIdentified', {
            credit_application_id: creditApplicationId,
            credit_application_source: source,
            page: window.location.pathname,
        });
        HyperDX.setGlobalAttributes({ creditApplicationId });
        reportAction('CreditApplicationIdentified', {
            componentName,
            actionType: 'CreditApplicationIdentified',
            actionURL: window.location.pathname,
            actionData: { creditApplicationId, creditApplicationSource: source },
        });
    }, [analytics]);
    return { trackCreditApplicationId, trackProveSessionId };
};
export default useIdentifierTracking;
